import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-trade-barometer-v2.component.scss';
var FormItemTradeBarometerV2 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemTradeBarometerV2, _super);
    function FormItemTradeBarometerV2(element) {
        return _super.call(this, element) || this;
    }
    FormItemTradeBarometerV2.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
        //Privacy and Marketing Concerns
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
    };
    FormItemTradeBarometerV2.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) { return item.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length == 0) {
                _this.submitForm(_form);
                var documentURL = document.querySelector('input[name=documentURL]');
                window.open(documentURL.value, '_blank');
            }
        }); });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
    };
    FormItemTradeBarometerV2.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        var fieldsContainer = form.querySelector('.form__fields--container');
        // additional containers
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        // fields
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var _serviceType = form.querySelector("input[name=service-type]");
        var email = this.form.querySelector("input[name=email]");
        var recipient = this.form.querySelector("input[name=recipient]");
        var subject = this.form.querySelector("input[name=subject]");
        var product = this.form.querySelector("input[name=product]");
        var _postData = {
            'recipient': (recipient ? recipient.value : ""),
            'subject': (subject ? subject.value : ""),
            'email': (email ? email.value : ""),
            'product': (product ? product.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'serviceType': (_serviceType ? _serviceType.value : ""),
            'dataPrivacyConsent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO")),
            'dataSharingGroup': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharing3rdParty': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingBoarders': this.getDataConsentValue(form, 'data-sharing-boarders'),
        };
        // loader + hide form
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/bcleadUtils/trade-point-lead";
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config).then(function (response) {
            loader.classList.remove('active');
            if (!response.data || (response.data.toString().toLowerCase().includes('invalid'))
                || response.data['error'] === 'true') {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                thankYou.classList.add('active');
                success.classList.remove('active');
                success.classList.add('hidden');
                error.classList.remove('hidden');
                error.classList.add('active');
            }
            else {
                if (response.code) {
                    analyticsService.dtmFormComplete('complete', response.code);
                }
                else if (response.status) {
                    analyticsService.dtmFormComplete('complete', response.status);
                }
                else {
                    analyticsService.dtmFormComplete('complete', '200');
                }
                thankYou.classList.add('active');
                error.classList.remove('active');
                error.classList.add('hidden');
                success.classList.remove('hidden');
                success.classList.add('active');
            }
        }).catch(function (response) {
            // service failed
            console.log(response);
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    FormItemTradeBarometerV2.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    return FormItemTradeBarometerV2;
}(Base));
export { FormItemTradeBarometerV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-trade-barometer-v2/form-item-trade-barometer-v2.component.ts
// module id = 1047
// module chunks = 0